'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ProductReview } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductRating } from '@eliadmin/core/src/components/product/detail/product-rating';
import { HtmlDescription } from '../../ui/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface ProductReviewCardProps {
  review: ProductReview;
}

export function ProductReviewCard({ review }: ProductReviewCardProps) {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-4 rounded-[24px] border border-black/5 bg-white p-4 sm:gap-5 sm:p-5 lg:gap-6 lg:p-6">
      <ProductRating
        hideTextRating
        rating={review.rating}
        className={{
          starDisabled: 'fill-white stroke-[#EDB000] stroke-[1px]',
          starIcon: 'fill-[#EDB000] stroke-[#EDB000] stroke-[1px]',
        }}
      />
      <HtmlDescription
        color="foreground"
        content={review.review}
        className={cn('w-full', 'ea-product-review-card__description')}
        size="sm"
      />
      <div className="flex w-full items-center justify-start gap-2">
        <Image
          src={review?.image?.url || '/images/user.png'}
          alt={resolveImageAlt(review?.image, review?.name)}
          width={0}
          height={0}
          className="max-h-10 min-h-10 min-w-10 max-w-10 rounded-full object-cover object-center"
          sizes="40px"
        />
        <p className="text-sm font-semibold tracking-tight ">
          {review.name} {review.surname}
        </p>
      </div>
    </div>
  );
}
